export const iconFontAwesomeMedicalHealthCommentMedical = (
	<i className="fa-solid fa-comment-medical"></i>
);
